export { default } from './cannabinoids-view';
export type { NoidType } from './cannabinoids-util';
